import { Button }              from 'antd';
import Status                  from 'components/Stand/Status';
import rights                  from 'utils/rights';
import { STATUS_CONVERTER }    from 'utils/constants';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import StandMessageModel       from 'models/StandMessageModel';
import MessageModel            from 'models/MessageModel';
import currentSession          from 'utils/currentSession';
import StandModel              from 'models/StandModel';

const validationMessageContent =
  'Cher exposant, cher décorateur.\n' +
  'Après contrôle le projet de votre stand est conforme au règlement de décoration du salon, merci de cliquer sur "valider" pour confirmer cette validation.\n' +
  'Cordialement.\n' +
  '\n' +
  'Dear exhibitor, dear decorator. After inspection, the project of your stand complies with the decoration rules of the show. Please click on "Validate" to confirm this validation.\n' +
  'Best regards.';

const getAdditionalContent = (
    stand: StandModel,
    openNewStandMessageFormModal: (standMessage: StandMessageModel, message: MessageModel) => void,
    intl: any
) => {
  if (stand.status === STATUS_CONVERTER.validated) {
    return {
      additionalContent: (
        <Status additionalClass="status-big" status={stand.get('status', 1)}>
          <FormattedMessageWrapper id="Les plans sont confirmés" />
        </Status>
      ),
      status: STATUS_CONVERTER.validated,
      withConfirmation: false,
      withPlans: false,
    };
  }

  if (!currentSession.isStandist) {
    if (stand.status === STATUS_CONVERTER.pendingVerification) {
      return {
        additionalContent: (
          <>
            {rights.for.stand.newStatus.validatedPlans && (
              <Button
                block
                htmlType="button"
                onClick={() =>
                  openNewStandMessageFormModal(
                    new StandMessageModel({
                      additionalContent: intl.formatMessage({
                        id: 'validationMessageContent',
                      }),
                      content: validationMessageContent,
                      newStandStatus: STATUS_CONVERTER.pendingConfirmation,
                    }),
                    new MessageModel({
                      content: validationMessageContent,
                    }),
                  )
                }
                style={{ marginBottom: 5 }}
                type="primary"
              >
                <FormattedMessageWrapper id="Valider les plans" />
              </Button>
            )}
            {rights.for.stand.newStatus.validatedPlans && (
              <Button
                block
                color="danger"
                htmlType="button"
                onClick={() =>
                  openNewStandMessageFormModal(
                    new StandMessageModel({
                      newStandStatus: STATUS_CONVERTER.waiting,
                    }),
                    new MessageModel(),
                  )
                }
              >
                <FormattedMessageWrapper id="Refuser les plans" />
              </Button>
            )}
          </>
        ),
        status: STATUS_CONVERTER.pendingVerification,
        withConfirmation: false,
        withPlans: false,
      };
    }

    if (stand.status === STATUS_CONVERTER.pendingConfirmation) {
      return {
        additionalContent: (
          <div className="status-waiting-confirmation">
            <FormattedMessageWrapper id="Les plans sont vérifiés. Ils sont en attente de confirmation de la part de l'exposant." />
          </div>
        ),
        status: STATUS_CONVERTER.pendingConfirmation,
        withConfirmation: false,
        withPlans: false,
      };
    }
  }

  if (currentSession.isStandist) {
    if (stand.status === STATUS_CONVERTER.waiting) {
      return {
        additionalContent: (
          <Button
            block
            htmlType="button"
            onClick={() =>
              openNewStandMessageFormModal(
                new StandMessageModel({
                  newStandStatus: STATUS_CONVERTER.pendingVerification,
                }),
                new MessageModel(),
              )
            }
            type="primary"
          >
            <FormattedMessageWrapper id="Déposer mes plans" />
          </Button>
        ),
        status: STATUS_CONVERTER.waiting,
        withConfirmation: false,
        withPlans: true,
      };
    }

    if (stand.status === STATUS_CONVERTER.pendingVerification) {
      return {
        additionalContent: (
          <div className="status-waiting-verification">
            <FormattedMessageWrapper id="Vos plans sont bien enregistrés et sont en attente de vérification par notre équipe. Nous vous enverrons un message dès qu'ils seront validés." />
          </div>
        ),
        status: STATUS_CONVERTER.pendingVerification,
        withConfirmation: false,
        withPlans: false,
      };
    }

    if (stand.status === STATUS_CONVERTER.pendingConfirmation) {
      return {
        additionalContent: (
          <Button
            block
            htmlType="button"
            onClick={() =>
              openNewStandMessageFormModal(
                new StandMessageModel({
                  newStandStatus: STATUS_CONVERTER.validated,
                }),
                new MessageModel(),
              )
            } // default flag
            type="primary"
          >
            <FormattedMessageWrapper id="Confirmer vos plans ici" />
          </Button>
        ),
        status: STATUS_CONVERTER.pendingConfirmation,
        withConfirmation: true,
        withPlans: false,
      };
    }
  }

  return {
    additionalContent: null,
    status: '',
    withConfirmation: false,
    withPlans: false,
  };
};

export default getAdditionalContent;
